const TYRO_FORMATTING_TAGS = [
  'MEDIUM_CENTRED',
  'LARGE_CENTRED',
  'MEDIUM_BOLD',
  'MEDIUM_RIGHT',
  'MEDIUM',
  'SMALL',
  'LARGE',
  'DOUBLE_HEIGHT',
  'BOLD',
  'ITALIC',
  'NEW_LINE',
  'LINE_FEED',
  'FORM_FEED',
  'START_OF_PAGE',
  'END_OF_PAGE',
];

export const sanitizeTyroTextReport = (text = '') => {
  if (!text) return '';

  const lines = text.split('\\n');
  const processedLines = lines.map(line => {
    let processedLine = line;
    // Remove all known tags
    TYRO_FORMATTING_TAGS.forEach(tag => {
      processedLine = processedLine.replace(new RegExp(`${tag}:?`, 'g'), '');
    });
    // Replace specific tags with characters
    processedLine = processedLine.replace(/NEW_LINE/g, '\n');
    processedLine = processedLine.replace(/FORM_FEED/g, '\n\n---\n\n');
    
    // Cleanup any leftover colons and trim whitespace
    return processedLine.replace(/^:/, '').trim();
  });

  return processedLines.join('\n').replace(/\n{3,}/g, '\n\n');
};

export const parseTyroXmlReport = (xmlString = '') => {
  if (!xmlString) return null;
  try {
    const parser = new window.DOMParser();
    const doc = parser.parseFromString(xmlString, 'text/xml');
    if (doc.getElementsByTagName('parsererror').length > 0) {
      throw new Error('Invalid XML');
    }

    const summary = {};
    const totalNode = doc.querySelector('Totals');
    if (totalNode) {
      summary.totalAmount = totalNode.getAttribute('totalAmount') || totalNode.textContent;
      summary.totalCount = totalNode.getAttribute('count') || totalNode.getAttribute('transactions');
    }

    const batches = Array.from(doc.querySelectorAll('Batch')).map((batch) => ({
      cardType: batch.getAttribute('cardType') || batch.querySelector('CardType')?.textContent,
      count: batch.getAttribute('count') || batch.querySelector('Count')?.textContent,
      amount: batch.getAttribute('amount') || batch.querySelector('Amount')?.textContent,
    }));

    return {
      summary,
      batches,
    };
  } catch (error) {
    console.error('Failed to parse Tyro XML report', error);
    return null;
  }
};
